import React,{useState} from 'react'
import {styles} from './styles'

import './styles.css'
const Avatar = props => {

const [hovered, setHovered] = useState(false)

  return (
    <div style={props.style}>

<div className='transition-3'
    style={{
      ...styles.avatarHello,
      ...{ opacity:hovered ? '1' : '0'}
    }}
    
    >Hey, it's Chris!!</div>


<div

className='transition-3'

onMouseEnter={() => setHovered(true)}
onMouseLeave={() => setHovered(false)}

onClick={() => props.onClick && props.onClick()}
style={{
  ...styles.chatWithMeButton,
  ...{ border: hovered ? '4px solid purple' : '1px solid white'}
}}


/>


    </div>
  )
}

export default Avatar